module.exports = __webpack_public_path__ + "img/30.6854b540.png";